<template>
  <div>
    <div class="row-new-row">
      <div class="row new-row">
        <div class="tipo-persona-selector col-4" 
        v-bind:id="`tp-${tipoPersona.tipoPersonaId}`"
        v-for="tipoPersona in tipoDePersonas" v-bind:key="tipoPersona.tipoPersonaId"
        @click="cambiarTipoPersona(tipoPersona.tipoPersonaId)">
             <h3>{{ tipoPersona.nombre }}</h3>
            </div>
      </div>
      <div class="row new-row">
        <div class="col-4">
          <span>Nombre:</span>
        </div>
        <div class="col-4">
          <span>Apellido Paterno:</span>
        </div>
        <div class="col-4">
          <span>Apellido Materno:</span>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <input type="text" class="form-control" v-model="persona.nombre" v-bind:disabled="deshabilitado"/>
        </div>
        <div class="col-4">
          <input type="text" class="form-control" v-model="persona.paterno" v-bind:disabled="deshabilitado"/>
        </div>
        <div class="col-4">
          <input type="text" class="form-control" v-model="persona.materno" v-bind:disabled="deshabilitado"/>
        </div>
      </div>
      <div class="row new-row">
        <div class="col-4">
          <span>Adscripción:</span>
        </div>
        <div class="col-4">
          <span>Puesto:</span>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <C011Adscripciones
          v-on:valorParaElPadre="cambioAdscripcion"
          :prefijo="enumeraciones.etiquetasDeHTML.Select"
          :tipo="enumeraciones.tiposDeSelect.Seleccione"
          :idDelInput="'catalogoAdscripcion'"
          :parametros="{ valorDefinido: -1, adscripcionId: null }"
          :valorDefinido="-1"
        >
        </C011Adscripciones>
        </div>
        <div class="col-4">
          <input type="text" class="form-control" v-model="persona.puesto" v-bind:disabled="deshabilitado"/>
        </div>
        <div class="col-4">
          <input type="button" class="form-control" value="Agregar" @click="agregarPersona" v-bind:disabled="deshabilitado"/>
        </div>
      </div>
      <div class="row new-row">
        <table class="table table-striped table-light table-hover">
          <thead class="thead-dark">
            <tr>
              <th class="col-2">Nombre</th>
              <th class="col-2">Apellido Paterno</th>
              <th class="col-2">Apellido Materno</th>
              <th class="col-3">Adscripcion</th>
              <th class="col-2">Puesto</th>
              <th class="col-1">Acciones</th>
            </tr>
          </thead>
          <tbody class="text-dark">
             <tr
              v-for="(personaTabla, indicePersona) in personas.filter(
                (personaTabla) =>
                  personaTabla.tipoPersonaId === persona.tipoPersonaId
              )"
              v-bind:key="indicePersona"
            >
              <td>{{ personaTabla.nombre }}</td>
              <td>{{ personaTabla.paterno }}</td>
              <td>{{ personaTabla.materno }}</td>
              <td>{{ personaTabla.adscripcion && personaTabla.adscripcion.nombre }}</td>
              <td>{{ personaTabla.puesto }}</td>
              <td></td>
            </tr>
             <tr>
              <td
                colspan="6"
                v-if="
                  personas.filter(
                    (personaTabla) =>
                      personaTabla.tipoPersonaId === persona.tipoPersonaId
                  ).length === 0
                "
              >
                No se ha registrado {{ tipoDePersonas[persona.tipoPersonaId-1].nombre.toLowerCase() }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
import { Persona } from "@/components/SIFA/Comun/Modelos/Persona.js";
export default {
  data() {
    return {
      enumeraciones,
      catalogos, 
      personas: [],
      persona: new Persona(),
      tipoDePersonas: [
        { tipoPersonaId: 1, nombre: "Denunciante" },
        { tipoPersonaId: 2, nombre: "Presunto Responsable" },
        { tipoPersonaId: 3, nombre: "Terceros" },
      ]
    };
  },
  props: {
    prop_listaDeAcuerdos: Array[Acuerdo],
    deshabilitado: false
  },
  components: {
    C011Adscripciones: catalogos.SIFA.C011Adscripciones,
  },
  methods: {      
      agregarPersona(){
          this.persona.cargarDatosParaFormulario(['insertar-persona']);
          this.personas.push(this.persona);
          const auxTipoPersona = this.persona.tipoPersonaId;
          this.persona = new Persona();
          this.persona.cargarDatosParaFormulario(['datos-generales']);
          this.persona.tipoPersonaId = auxTipoPersona;
          $("#catalogoAdscripcion").val('-1');
          this.$emit("valorParaElPadre", this.personas);
      },
      cambiarTipoPersona(tipoPersonaId){
          this.persona.tipoPersonaId = tipoPersonaId;
          const pestanas = document.querySelectorAll('.tipo-persona-selector');
            pestanas.forEach(pestana => pestana.classList.remove('tp-active'));
          document.getElementById(`tp-${tipoPersonaId}`).classList.add("tp-active")
      },
      cambioAdscripcion(datos) {
      //Administra los cambios en el componente de Tipo de Estado De Admision
      //console.log(datos[1])
      catalogos;
      this.persona.adscripcionId = parseInt(datos[0].target.value);
      if(this.persona.adscripcionId > 0)
      this.persona.adscripcion = {adscripcionId: datos[1].adscripcionId, nombre: datos[1].nombre}
    },
  },
  created: function created() {
    this.persona.cargarDatosParaFormulario(['datos-generales']);
  },
  mounted: function mounted() {
      document.getElementById("tp-1").classList.add("tp-active")
    if (this.prop_listaDeAcuerdos)
      this.listaDeAcuerdos = this.prop_listaDeAcuerdos;
  },
  computed: {},
};
</script>

<style scoped>
span {
  font-weight: bold;
}

b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.bigtextarea {
  height: 100px;
}
.tipo-persona-selector{
    border-color: #212529;
    color: white;
    border-style: solid;
    background-color: #2e2f31;
    padding: 10px;
    cursor: pointer;
    text-align: center;
}
.tp-active{
    background-color: white;
    color: #212529;
}

</style>



// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/Involucrados.vue